﻿

(() => {
    angular.module('fliptoWeb')
        .controller('NavigationCtrl', ['$scope', 'ApiService',
        function ($scope, ApiService) {
            var vm = this;

            vm.menuActive = true;

            //handles hide/show of sections
            //required for directive get-started
            vm.activeSection = 0;

            //handles switching sections
            //required for directive get-started
            vm.activateSection = function (section) {
                //updateSection method is defined inside the directive.
                vm.dirGetStartedAccessor.updateSection(section);
                vm.activeSection = section;
            }

            //model property accessor for directive/controller communications
            //required for directive get-started
            vm.dirGetStartedAccessor = {
                activateSection: vm.activateSection,
                activeSection: vm.activeSection
            };

            vm.name = "";
            vm.email = "";
            vm.phone = "";

            vm.getStarted = function () {
                vm.menuActive = false;
            }

            vm.submit = function (leadType) {

                var data = {
                    Name: vm.name,
                    Email: vm.email,
                    Phone: vm.phone,
                    //TimeZone:null,
                    TimeRange: 0,
                    LeadType: 0,
                    Partner: ""
                }

                ApiService.GetStarted_Post(data)
                    .then(function (response) {

                    vm.activateSection(4);
                });
            }


        }]);
})()
